import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/siteData";

export const EmergencyBar = () => {
  return (
    <a
      data-testid="emergency-bar"
      href={COMPANY.phoneHref}
      className="fixed top-0 inset-x-0 z-[55] h-9 md:h-10 flex items-center justify-center bg-[#FF3B30] text-white group"
    >
      <div className="flex items-center gap-2 md:gap-3 px-4 text-[12px] md:text-sm font-semibold tracking-tight">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
        </span>
        <span className="uppercase tracking-wide hidden sm:inline">24/7 Emergency Plumbing</span>
        <span className="uppercase tracking-wide sm:hidden">24/7 Emergency</span>
        <span className="opacity-60">—</span>
        <span className="inline-flex items-center gap-1.5 underline decoration-white/40 underline-offset-2 group-hover:decoration-white transition-[text-decoration-color]">
          <Phone className="h-3.5 w-3.5 md:h-4 md:w-4" />
          Call now: {COMPANY.phone}
        </span>
      </div>
    </a>
  );
};
